@if (initialized) {
    <!-- ============================================================ -->
    <!-- STICKY HEADER SECTION                                         -->
    <!-- ============================================================ -->
    <div class="sticky top-0 z-5 surface-0 pb-4">
        <!-- BREADCRUMB -->
        <div class="flex align-items-center gap-2 mb-3 text-sm text-color-secondary">
            <i class="fa-regular fa-house"></i>
            <span>Logik</span>
            <i class="fa-solid fa-chevron-right text-xs"></i>
            <span>Berechnungslogik</span>
            <i class="fa-solid fa-chevron-right text-xs"></i>
            <span class="text-primary font-medium">Neu erstellen</span>
        </div>

        <!-- HEADER -->
        <div class="surface-card border-round-lg p-3 mb-3 flex align-items-center gap-3">
            <i class="fa-regular fa-wand-magic-sparkles text-2xl text-primary"></i>
            <div class="flex flex-column">
                <span class="text-xl font-semibold">Berechnungslogiktyp erstellen</span>
                <span class="text-sm text-color-secondary">
                    Schritt {{ activeStep + 1 }} von {{ stepItems.length }}
                </span>
            </div>
        </div>

        <!-- STEPPER HEADER -->
        <mvs-stepper
            [stepItems]="stepItems"
            [activeStep]="activeStep"
            [showStepName]="true"
            [fullPage]="false"
        ></mvs-stepper>
    </div>

    <!-- ============================================================ -->
    <!-- STEP CONTENT                                                  -->
    <!-- ============================================================ -->
    <div class="surface-card border-round-lg p-4 mt-3 wizard-content">
        @switch (activeStep) {

            <!-- STEP 1: Grundlagen -->
            @case (0) {
                <lg-poc-wizard-step-basics></lg-poc-wizard-step-basics>
            }

            <!-- STEP 2: Logik-Blöcke -->
            @case (1) {
                <lg-poc-wizard-step-mapping
                    (onGoBack)="onGoBack(1)"
                    (onFinish)="onFinish()"
                ></lg-poc-wizard-step-mapping>
            }

            <!-- STEP 3: Fertig -->
            @case (2) {
                <lg-poc-wizard-step-done
                    (onNavigate)="onFinish()"
                ></lg-poc-wizard-step-done>
            }
        }
    </div>
}
